module.exports = __webpack_public_path__ + "static/img/toujiao4.01db92b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/toujiao4.jpg
// module id = YJmv
// module chunks = 1